import React from 'react';
import Container from '@mui/material/Container';
import { Avatar, Box,  Grid, Typography } from '@mui/material';
import LocalPhoneIcon from '@mui/icons-material/LocalPhone';
import { Facebook, Instagram, Twitter } from "@mui/icons-material";
import { Link } from 'react-router-dom';
import MailOutlineIcon from '@mui/icons-material/MailOutline';
import { useAuth } from '../../hooks/useAuth';
import TelegramIcon from '@mui/icons-material/Telegram';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';


function Footer() {
    const { authDataLang } = useAuth()
     

  return (
    <Box
      component="footer"
      dir={authDataLang?.view_sts ? "rtl" : "ltr"}
      sx={{
          backgroundColor: 'primary.main',
          p: 6,
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={5} >
          <Grid item xs={12} sm={4}>
            <Typography variant="h4" color="white" gutterBottom fontFamily={"Segoe UI"}>
              <Link to='/'>
                  <Avatar src={authDataLang?.site_langs?.image_logo} alt={authDataLang?.site_langs?.image_logo_alt} height="70px" />
              </Link>
              {authDataLang?.site_langs?.desc_about_me}
            </Typography>
            <Typography variant="h6" color="primary.light" fontFamily={"Segoe UI"}>
                {authDataLang?.site_langs?.about_me}
            </Typography>
          </Grid>
          <Grid item xs={12} sm={4} 
              sx={{textAlign: 'center'}}
            >
              <Typography 
                  variant="h4" 
                  color="primary.light" gutterBottom 
                  fontFamily={"Segoe UI"}
                >
                  {authDataLang?.site_langs?.desc_follow_me}
              </Typography>
              {authDataLang?.site_langs?.facebook_link &&
                  <Link href={authDataLang?.site_langs?.facebook_link} color="primary.light">
                      <Facebook sx={{fontSize: 40, color: 'primary.light'}}/>
                  </Link>
              }
              {authDataLang?.site_langs?.instagram_link &&
                  <Link
                      href={authDataLang?.site_langs?.instagram_link}
                      color="primary.light"
                      sx={{ pl: 1, pr: 1 }}
                    >
                      <Instagram 
                          sx={{
                            fontSize: 40, 
                            color: 'primary.light'
                          }} 
                        />
                  </Link>
              }
              {authDataLang?.site_langs?.twitter_link &&
                  <Link href={authDataLang?.site_langs?.twitter_link} >
                      <Twitter 
                          sx={{
                            fontSize: 40, 
                            color: 'primary.light'
                          }} 
                        />
                  </Link>
              }
              {authDataLang?.site_langs?.telegram_link &&
                  <Link href={authDataLang?.site_langs?.telegram_link} >
                      <TelegramIcon 
                          sx={{
                            fontSize: 40, 
                            color: 'primary.light'
                          }} 
                        />
                  </Link>
              }
              {authDataLang?.site_langs?.whatsapp_link &&
                  <Link href={authDataLang?.site_langs?.whatsapp_link} >
                      <WhatsAppIcon 
                          sx={{
                            fontSize: 40, 
                            color: 'primary.light'
                          }} 
                        />
                  </Link>
              }
          </Grid>
          
          <Grid item xs={12} sm={4} >
            <Typography 
                variant="h4" 
                color="primary.light" 
                gutterBottom fontFamily={"Segoe UI"}
              >
              {authDataLang?.site_langs?.desc_call_me}
            </Typography>
            {authDataLang?.site_langs?.site_address &&
                <Typography 
                    variant="h6" 
                    color="primary.light" 
                    fontFamily={"Segoe UI"}
                  >
                    <MailOutlineIcon />
                    {authDataLang?.site_langs?.site_address}
                </Typography>
            }
            {authDataLang?.site_langs?.site_email &&
                <Typography variant="div" color="primary.light" 
                    noWrap
                    fontFamily={"Segoe UI"}
                    sx={{textAlign: 'left'}}
                  >
                    <MailOutlineIcon />
                    {authDataLang?.site_langs?.site_email}
                </Typography>
            }
            {authDataLang?.site_langs?.site_phone &&
                <Typography variant="h6" color="primary.light" fontFamily={"Segoe UI"} 
                    dir={authDataLang?.view_sts ? "ltr" : "rtl"}
                    noWrap
                    sx={{textAlign: 'left'}}
                  >
                    {authDataLang?.site_langs?.site_phone}
                    <LocalPhoneIcon />
                </Typography>
            }
          </Grid>
        </Grid>
        <Box mt={5} >
          <Typography 
              noWrap
              ariant="body2" 
              color="primary.light" 
              align="center"
              fontSize={'small'}
              dir={authDataLang?.view_sts ? "ltr" : "rtl"}
              width='100%'
            >
            {"Copyright © "}
              <Link color="primary.light" href="https://etec.ir/">
                  <u>{authDataLang?.site_langs?.site_name}</u>
              </Link>{" "}
              {new Date().getFullYear()}
              {"."}
          </Typography>
        </Box>
      </Container>
    </Box>
  )
}

export default Footer
